import { useState } from 'react';
import { useSelector } from 'react-redux';
import { app, cart, type RootState } from 'core';
import { Drawer } from 'ui/components';

import { CartBalance, CartCta, CartItems, CartProgress, Coupon, EmptyCart } from './widgets';
import { UnavailableItemsMessage } from './widgets/UnavailableItemsMessage/UnavailableItemsMessage';
import { UnavailableItems } from './widgets/UnavailableItems/UnavailableItems';
import { HeaderCart } from './widgets/HeaderCart/HeaderCart';

export const Cart = () => {
  const { closeCart } = app.commands.useAppCommand();
  const [openUnavailableItems, setOpenUnavailableItems] = useState(false);
  const isCartActive = app.hooks.useApp('isCartActive');
  const hasCartItem = cart.hooks.useCartPropertyByKey('hasItem');
  const unavailableItems = useSelector((state: RootState) => state.cart.data.unavailableItems);

  const handleOpenUnavaialableItems = () => {
    setOpenUnavailableItems(true);
  };

  const handleClose = () => {
    setOpenUnavailableItems(false);
  };

  return (
    <Drawer
      anchor="right"
      onClose={closeCart}
      open={isCartActive}
      size="default"
      title="Pedido atual"
      withoutHeader
    >
      {hasCartItem ? (
        <>
          <HeaderCart
            openUnavailableItems={openUnavailableItems}
            handleClose={handleClose}
            closeCart={closeCart}
          />
          {unavailableItems.length > 0 && !openUnavailableItems && (
            <UnavailableItemsMessage setOpen={handleOpenUnavaialableItems} />
          )}
          {openUnavailableItems ? (
            <UnavailableItems />
          ) : (
            <>
              <CartProgress />
              <CartBalance />
              <Coupon />
              <CartItems />
              <CartCta />
            </>
          )}
        </>
      ) : (
        <>
          <HeaderCart
            openUnavailableItems={openUnavailableItems}
            handleClose={handleClose}
            closeCart={closeCart}
          />
          <EmptyCart />
        </>
      )}
    </Drawer>
  );
};
